/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Cart/CartItems',[
    'jquery',
    'lodash',
    './CartManager',
    'global/all',
    'modules/Delivery/DeliveryOptions',
    'modules/Product/ProductService',
    'modules/InStorePickup/InStorePickup'
], function ($, _, CartManager, Roc, DeliveryOptions, ProductService, InStorePickup) {
    'use strict';

    var isLoggedIn;
    var signInUrl;
    var ispunchout;
    var addressBookUrl;
    var currentCart;
    var countries;

    function getItemData(element, attr) {
        return $(element).parents('.itemWrapper').attr('data-' + attr);
    }

    /* Events */
    function removeItemEvt() {
        $(document).on('click', '.removeCartItem', function () {
            Roc.UI.confirm('Are you sure you want to remove this item?', $.proxy(function () {
                var itemId = getItemData(this, 'item-id');
                var dataProductId = getItemData(this, 'product-id');
                Roc.UI.block();
                CartManager.removeOrderItem(itemId, dataProductId);
            }, this));
        });
    };

    function saveItemEvt() {
        $(document).on('click', '.saveCartItem', function (e) {
            var itemId = getItemData(this, 'item-id');
            Roc.Core.lockButton(e.currentTarget);
            Roc.UI.block();
            CartManager.saveOrderItem(itemId);
        });
    };

    function reload(order) {
        currentCart = order;

        var recipients = [];

        if (order !== undefined && order !== null) {
            _.forEach(order.recipients,
                function (r) {
                    _.forEach(r.items,
                        function (item) {
                            var recipient = _.cloneDeep(r);
                            _.assign(item.deliveryOptions, {
                                'addressBookUrl': addressBookUrl,
                                'signInUrl': signInUrl
                            });
                            recipient.items = [item];
                            recipients.push(recipient);
                        });
                });
        }
        
        var isQuote = !!order && !!order.customFields && !!order.customFields.quoteId;
        var viewModel = {
            'isLoggedIn': isLoggedIn,
            'recipients': recipients,
            'isQuote': isQuote,
            'isPunchout': ispunchout
        };

        for (var i = 0; i < viewModel.recipients.length; i++) {
            for (var j = 0; j < viewModel.recipients[i].items.length; j++) {
                var deliveryOptions = viewModel.recipients[i].items[j].deliveryOptions;
                deliveryOptions.defaultCountryCode = window.RocConfig.defaultCountryCode;
                deliveryOptions.enableInternationalShipping = window.RocConfig.shipping.enableInternationalShipping;
                deliveryOptions.countries = countries;
            }
        }
        
        Roc.UI.renderFormTemplate('#cart-Tmp', viewModel, $('#cartItemsListing')).then(function () {
            Roc.UI.unblock();
        });
    };

    function getCart() {
        Roc.UI.block();
        CartManager.getCurrentCart();
    };

    function updateAfterItemChanged(response) {
        if (response && response.success === true) {
            var $qtyTextbox = $('#qtyTextBox' + response.orderItemId);
            var $productList = $qtyTextbox.closest('#cartItemsListing');
            var $hiddenElem = $qtyTextbox.closest('.itemWrapper');
            var itemsCount = $productList.find('.itemWrapper').length;

            if (itemsCount <= 1) {
                $hiddenElem = $productList;
            }

            $hiddenElem.slideUp();
            getCart();
        } else {
            Roc.UI.ajaxErrorPopup(response, 'An error occurred while trying to update the item in your cart.');
        }
    };

    function updateAfterItemUpdate(response) {
        if (response && response.success === false) {
            var errorMessage = 'An error occurred while trying to update the item in your cart.';
            if (response.details !== null && response.details.errors !== null && response.details.errors.length > 0) {
                errorMessage = '';
                for (var i = 0; i < response.details.errors.length; i++) {
                    errorMessage += response.details.errors[i].errorMessage + '\n';
                }
            }
            Roc.UI.displayErrorPopup(errorMessage, 'There seems to be a problem');
        } else if (response && response.exceptionMessage) {
            Roc.UI.displayErrorPopup(response.exceptionMessage);
        }

        getCart();
    };

    function deliveryOptionChanged(data) {
        Roc.UI.block();
        var deliveryOptions = DeliveryOptions.getProductDeliveryOptions(data.productId, data.orderItemId);
        CartManager.updateCartItemDelivery(data.orderItemId, deliveryOptions, null);
    }

    function setPickupLocationForCartItem(cartItemId, store) {
        var deliveryOptions = {
            'deliveryType': ' Pickup',
            'pickupLocationId': store.location.id
        };
        Roc.UI.block();
        CartManager.updateCartItemDelivery(cartItemId, deliveryOptions, null);
    }

    function findStoreEvt() {
        Roc.UI.siteBody
            .off('click', '[data-roc-action="findAnotherStore"]')
            .on('click', '[data-roc-action="findAnotherStore"]', function () {
                var itemId = getItemData(this, 'item-id');
                var productId = getItemData(this, 'product-id');
                ProductService.getById(productId).then(function (product) {
                    InStorePickup.findPickupStore(product).then(function (store) {
                        setPickupLocationForCartItem(itemId, store);
                    });
                }, function () {
                    Roc.UI.displayErrorPopup('There was an error while trying to get product details.');
                });
            });
    }

    function bindEvents() {
        removeItemEvt();
        saveItemEvt();
        findStoreEvt();
        Roc.EventManager.bind(Roc.Events.cart.UPDATE_ITEM, updateAfterItemUpdate);
        Roc.EventManager.bind(Roc.Events.cart.REMOVE_ITEM, updateAfterItemChanged);
        Roc.EventManager.bind(Roc.Events.cart.SAVE_ITEM, updateAfterItemChanged);
        Roc.EventManager.bind(Roc.Events.cart.MOVE_SAVED_ITEM, updateAfterItemChanged);
        Roc.EventManager.bind(Roc.Events.cart.GET_CURRENT_CART, reload);
        // Delivery options events
        Roc.EventManager.bind(Roc.Events.delivery.ADDRESS_BOOK_SELECTED, deliveryOptionChanged);
        Roc.EventManager.bind(Roc.Events.delivery.DELIVERY_OPTION_CHANGED, deliveryOptionChanged);
        Roc.EventManager.bind(Roc.Events.delivery.RECIPIENT_DATA_PROVIDED, deliveryOptionChanged);
    };

        function init(options) {
        bindEvents();
        isLoggedIn = options.isLoggedIn;
        signInUrl = options.signInUrl;
        addressBookUrl = options.addressBookUrl;
        
            ispunchout = options.ispunchout.toLowerCase() == "true" ? true : false;

        //bugfix: currentCart is undefined when calling PAGE_LOAD event
        if (options.model && options.model.orderCart) {
            currentCart = options.model.orderCart;
        }
        //bugfix END
        Roc.EventManager.notify(Roc.Events.cart.PAGE_LOAD, currentCart, true);
        if (options.model !== null) {
            countries = options.model.countries;

            $('#spanCartTotal').text('Cart (' + options.model.itemsInCart + ')');
            // Display errors from API

            if (options.model.errors && options.model.errors.length > 0) {
                Roc.UI.ajaxErrorPopup(options.model);
            }
        }
        reload(options.model !== null ? options.model.orderCart : null);

        var cartMsgCookie = Roc.Core.readCookie('cart-msg');
        if (cartMsgCookie !== null) {
            if (Roc.Core.isJson(cartMsgCookie)) {
                Roc.UI.ajaxErrorPopup(JSON.parse(cartMsgCookie));
            } else {
                Roc.UI.ajaxErrorPopup((cartMsgCookie));
            }

            Roc.Core.eraseCookie('cart-msg');
        }
    };

    var CartItems = {
        init: init,
        reload: reload,
        updateAfterItemChanged: updateAfterItemChanged,
        updateAfterItemUpdate: updateAfterItemUpdate
    };

    Roc.Logger.debug('CartItems.js Loaded:', CartItems);

    return CartItems;
});

